import { CreateRequestDTO } from '../types/raiseRequest.types';
import axiosInstance from '../utils/axiosInstance';
import {
  CREATE_TICKET_URL,
  GET_DETAILS_BY_PINCODE_URL,
  GET_REASONS_URL,
} from '../utils/environment';

export interface ReasonsResponse {
  ProductCode: string;
  ProblemName: string;
  ProblemDescription: string;
  ProblemCode: string;
}

export interface CreateRequestResponse {
  status: boolean;
  message: string;
}

export interface AreaDetail {
  Area: string;
  PinCode: string;
  Town: string;
  City: string;
  State: string;
}

export class RaiseRequestServices {
  static async getReasonsByProductCode(productCode: string): Promise<ReasonsResponse[]> {
    try {
      if (!productCode) {
        throw new Error('productCode is required');
      }

      let config = {
        maxBodyLength: Infinity,
        url: GET_REASONS_URL(productCode),
        headers: {
          Authorization: 'Basic V0hBVFNBUFA6d2FVU0VS',
        },
      };

      const response = await axiosInstance.request<ReasonsResponse[]>(config);

      if (response?.data) {
        return response?.data;
      }

      return [];
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  static async createRequest(
    dto: CreateRequestDTO,
    token: string,
  ): Promise<CreateRequestResponse | null> {
    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.post<CreateRequestResponse>(CREATE_TICKET_URL, dto, {
        headers,
      });

      return response?.data ?? null;
    } catch (error: any) {
      console.log('Error creating request: ', error);
      window.alert(error);
      return null;
    }
  }

  static async getDetailsByPincode(pincode: string): Promise<AreaDetail[]> {
    try {
      if (!pincode) {
        throw new Error('pincode is required');
      }

      const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Basic V0hBVFNBUFA6d2FVU0VS',
      };

      const response = await axiosInstance.get<AreaDetail[]>(GET_DETAILS_BY_PINCODE_URL(pincode), {
        headers,
      });

      return response?.data ?? [];
    } catch (error) {
      console.log('Error in getDetailsByPincode: ', error);
      return [];
    }
  }
}
